import { AxiosResponse } from "axios"
import { ICreateInvitation, IInvitation, LinkType } from "./types"
import { apiInstance } from "../base"
import { RoleType } from "../users"

export const getInvitations = (role_id?: RoleType): Promise<AxiosResponse<IInvitation[]>> => {
    return apiInstance.handler.get<IInvitation[]>(`/invitations`, {
        params: {
            role_id
        }
    })
}

export const deleteInvitation = (id: string): Promise<AxiosResponse<IInvitation>> => {
    return apiInstance.handler.delete<IInvitation>(`/invitations/${id}`)
}

export const createInvitation = (type: LinkType, data: ICreateInvitation): Promise<AxiosResponse<IInvitation>> => {
    return apiInstance.handler.post<IInvitation>(`/invitations/${type}`, data)
}
